import { autoinject } from 'aurelia-framework';
import { ApiService } from '../../utils/api-service';

@autoinject
export class CustomerService {
	selectedCustomerId: string;

	constructor(private api: ApiService) {
	}

	getCustomer(id: string): Promise<ICustomer> {
		return this.api.fetchJson(`customers/${id}`);
	}

	getCustomerType(customerid: string): Promise<CustomerType> {
		return this.api.fetch(`customers/${customerid}/type`).then(response => {
			return response.text() as Promise<CustomerType>;
		});
	}
}

export interface ICustomer {
	id: string;
	name: string;
}

export type CustomerType = 'Municipality' | 'Other';
